import * as SettingsActionTypes from '../../types/settings';

/**
 * Sets with revisions mode
 * @param {boolean} payload
 */
export const setWithRevisionSettings = (payload) => ({
    type: SettingsActionTypes.SET_WITH_REVISIONS,
    payload
});

/**
 * Sets with pre revisions mode
 * @param {boolean} payload
 */
export const setWithPreRevisionSettings = (payload) => ({
    type: SettingsActionTypes.SET_WITH_PRE_REVISIONS,
    payload
});

/**
 * Sets showPdfViewer (feature flag)
 * @param {boolean} payload
 */
export const setShowPdfViewer = (payload) => ({
    type: SettingsActionTypes.SHOW_PDF_VIEWER,
    payload
});
